import React from "react";
import Text from "../typography/Text";
import Box from "../box/Box";
import { IBaseTypeaheadItem } from "./Typeahead";
import Avatar from "../avatar/Avatar";
import Flex from "../box/Flex";

interface ISimpleTypeheadItem extends IBaseTypeaheadItem {
  logo?: string;
  description?: string;
}

interface ITextSelectItemProps {
  item: ISimpleTypeheadItem;
  active: boolean;
}

export default function SimpleTypeaheadItem({ item, active }: ITextSelectItemProps) {
  return (
    <Flex
      as="li"
      py={3}
      px={4}
      bg={active ? "blue.600" : "white"}
      color={active ? "white" : "black"}
      cursor="pointer"
      align="center"
    >
      <Avatar
        size="sm"
        borderColor="blue.600"
        showBorder={true}
        borderWidth={2}
        src={item.logo}
        name={item.label}
        mr={2}
      />
      <Box overflow="hidden">
        <Text fontSize="md" mb={0} isTruncated={true}>
          {item.label}
        </Text>
        {item.description && (
          <Text fontSize="sm" mb={0} isTruncated={true}>
            {item.description}
          </Text>
        )}
      </Box>
    </Flex>
  );
}
